<template>
    <div id="notfound-view">
        404 Error
    </div>
</template>